import React from "react";

import Box from "@busbud/design-system-components/dist/Box/Box";
import Label from "@busbud/design-system-components/dist/Label/Label";
import Stack from "@busbud/design-system-components/dist/Stack/Stack";

import { MAX_PASSENGERS_NUMBER } from "@app/constants/passengers";
import { useAppContext } from "@app/helpers/hooks";

import { ActionButton } from "./passenger-selector";
import { useStyles } from "./passenger-selector.styles";
import {
  usePassengerStore,
  addPassenger,
  removePassenger
} from "./passenger-store";

export const PassengerSelectorMobile = () => {
  const { translator } = useAppContext();

  return (
    <Box alignItems="center" justifyContent="space-between" display="flex">
      <Label size="lg" fontWeight="bold">
        {translator.t("!passengers-on-this-trip")}
      </Label>
      <Counter />
    </Box>
  );
};

const Counter = () => {
  const { classes } = useStyles();
  const { selected_seats_count } = usePassengerStore();

  return (
    <Stack alignItems="center">
      <ActionButton
        disabled={selected_seats_count <= 1}
        onClick={removePassenger}
        action="decrement"
      />
      <Label size="lg" fontWeight="bold" className={classes.counter}>
        {selected_seats_count}
      </Label>
      <ActionButton
        disabled={selected_seats_count === MAX_PASSENGERS_NUMBER}
        onClick={addPassenger}
        action="increment"
      />
    </Stack>
  );
};
